'use strict';

function filter(arr, fn) {
  var result = [];
  for (var i = 0, len = arr.length; i < len; i++) {
    var el = arr[i];
    if (i in arr && fn(el, i)) {
      result.push(el);
    }
  }
  return result;
}

module.exports = filter;


//////////////////
// WEBPACK FOOTER
// ./~/sugar-date/common/internal/filter.js
// module id = 52
// module chunks = 0